import { ProductRatingsAndReviews } from './ProductRatingsAndReviews';
import { ProductType } from './ProductType';
import { Seller } from './Seller';
import { Supplier } from './Supplier';
import { Color } from './Color';
import { Brand } from './Brand';
import { Status } from './Status';
import { Gender } from './Gender';
import { Category } from './Category';
import { SubCategory } from './SubCategory';
import { SizeChart } from './SizeChart';
import { City } from './City';
import { Occasion } from './Occasion';
import { SizeWiseProductsCount } from './SizeWiseProductsCount';
import { Store } from './Store';

export class Products {
    public id: string;
    public title: string;
    public title_fr: string;
    public shortDescription: string;
    public description: string;
    public shortDescription_fr: string;
    public description_fr: string;
    public productCode: string;
    public refundableDeposite: number = 0;
    public actualPrice: number = 0;
    public offerPrice: number = 0;
    public isDelayPenaltyPer: Boolean;
    public delayPenaltyCost: string;
    public delayPenaltyPer: number = 0;
    public productThumbNailImage: string;
    public availableQuantity: number = 0;
    public totalQuantity: number = 0;
    public inOrdersQuantity: number = 0;
    public productViewCount: number = 0;
    public productFansCount: number = 0;
    public likes: number = 0;
    public productImageList: Array<string>;
    public ratingAverage: number = 0;
    public isSizeAvailable: Boolean;
    public ratingsAndReviews: Array<ProductRatingsAndReviews>;
    public productTypeObj: ProductType;
    public commentOnProductList: Array<string>;
    public sellerObj: Seller;
    public supplierObj: Supplier;
    public colorObj: Color;
    public brandObj: Brand;
    public statusObj: Status;
    public genderObj: Gender;
    public categoryObj: Category;
    public subCategoryObj: SubCategory;
    public sizeChartObj: Array<SizeChart>;
    public createddate: Date;
    public cityObj: City;
    public availableCities: Array<City>;
    public occasionObj: Array<Occasion>;
    public sizeWiseProductsCount: Array<SizeWiseProductsCount>;
    public storeObj: Store;
}
